/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;left:0;top:0;right:0;bottom:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#e0e0e0}.splashscreen-logo[_ngcontent-%COMP%]{width:144px;height:144px;margin-bottom:16px}.splashscreen-text[_ngcontent-%COMP%]{font-size:18px;line-height:22px;padding-left:16px;padding-right:16px;padding-bottom:16px;text-align:center}"];
export { styles as styles };
